import STATUS_CODES from 'constants/statusCodes';
import { publicEnvConfig } from 'helpers/env';
import { isServerSide } from 'helpers/isServerSide';
import { redirect } from 'helpers/redirect';

export const onSuccess = (response) => response;

export const onError = (error) => {
	if (error.response && error.response.status === STATUS_CODES.UNAUTHORIZED) {
		redirect(`${publicEnvConfig.RESTURL_BASE}/bosssite`);
	}
	return Promise.reject(error);
};

export const setupAdminRedirectToBosssiteLoginInterceptor = (config, restClientInstance) => {
	if (config.bossiteAdminUser && !isServerSide()) {
		restClientInstance._axios.interceptors.response.use(onSuccess, onError);
	}
};
